export function setCookie(cName: string, cValue: any, exDays: number = 365) {
  const d = new Date();
  d.setTime(d.getTime() + (exDays * 24 * 60 * 60 * 1000));
  const expires = 'expires=' + d.toUTCString();
  document.cookie = cName + '=' + cValue + ';' + expires + ';path=/';
}
